/* ============================================
   MAD BXNNY · Theme JS
============================================ */

(function() {
  'use strict';

  // ============================================
  // MOBILE NAV
  // ============================================
  const navToggle = document.querySelector('.nav__toggle');
  const nav = document.querySelector('.nav');
  if (navToggle && nav) {
    navToggle.addEventListener('click', () => {
      nav.classList.toggle('is-open');
      navToggle.classList.toggle('is-open');
      document.body.style.overflow = nav.classList.contains('is-open') ? 'hidden' : '';
    });
    // close nav when clicking a link
    nav.querySelectorAll('a').forEach(a => {
      a.addEventListener('click', () => {
        nav.classList.remove('is-open');
        navToggle.classList.remove('is-open');
        document.body.style.overflow = '';
      });
    });
  }

  // ============================================
  // SCROLL REVEALS
  // ============================================
  function initReveals() {
    const reveals = document.querySelectorAll('.reveal:not(.is-revealed)');
    if (!('IntersectionObserver' in window)) {
      reveals.forEach(el => el.classList.add('is-revealed'));
      return;
    }
    const io = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-revealed');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -60px 0px' });
    reveals.forEach(el => io.observe(el));
  }
  initReveals();

  // ============================================
  // HEADER SCROLL STYLE
  // ============================================
  const header = document.querySelector('.header');
  if (header) {
    window.addEventListener('scroll', () => {
      if (window.scrollY > 50) {
        header.style.background = 'rgba(255, 251, 240, 0.95)';
        header.style.boxShadow = 'none';
      } else {
        header.style.background = 'rgba(255, 251, 240, 0.85)';
        header.style.boxShadow = 'none';
      }
    }, { passive: true });
  }

  // ============================================
  // EASTER EGG: triple-click footer wordmark
  // ============================================
  let clickCount = 0;
  let clickTimer = null;
  const footerWordmark = document.querySelector('.footer__wordmark');
  if (footerWordmark) {
    footerWordmark.addEventListener('click', () => {
      clickCount++;
      if (clickTimer) clearTimeout(clickTimer);
      clickTimer = setTimeout(() => { clickCount = 0; }, 600);
      if (clickCount === 3) {
        clickCount = 0;
        for (let i = 0; i < 8; i++) {
          const s = document.createElement('div');
          s.className = 'ee-sparkle';
          s.textContent = '✦';
          s.style.left = (20 + Math.random() * 60) + '%';
          s.style.top = (40 + Math.random() * 30) + '%';
          s.style.animationDelay = (i * 0.08) + 's';
          s.style.fontSize = (1.5 + Math.random() * 1.5) + 'rem';
          document.body.appendChild(s);
          setTimeout(() => s.remove(), 2000);
        }
      }
    });
  }

  // ============================================
  // SHOPIFY CART — AJAX add, drawer count, line updates
  // ============================================
  const moneyFormat = window.MADBXNNY_MONEY_FORMAT || '${{amount}}';

  function formatMoney(cents) {
    const value = (cents / 100).toFixed(2);
    return moneyFormat.replace(/\{\{\s*amount\s*\}\}/g, value);
  }

  const cartRoot = (window.Shopify?.routes?.root || '/').replace(/\/?$/, '/');
  const cartUrl = path => cartRoot + path;
  let cartQueue = Promise.resolve();

  function queueCartRequest(task) {
    const result = cartQueue.then(task, task);
    cartQueue = result.catch(() => {});
    return result;
  }

  async function cartRequest(path, options = {}) {
    const response = await fetch(cartUrl(path), {
      ...options,
      credentials: 'same-origin',
      headers: { Accept: 'application/json', ...options.headers },
    });
    const data = await response.json();
    if (!response.ok || data.status >= 400) {
      throw new Error(data.description || data.message || 'Please try again.');
    }
    return data;
  }

  function updateCartCount(cart) {
    document.querySelectorAll('[data-cart-count]').forEach(el => {
      el.textContent = cart.item_count;
    });
    document.querySelectorAll('.nav__cart, .nav__cart-mobile').forEach(el => {
      el.setAttribute('aria-label', `Cart, ${cart.item_count} items`);
    });
  }

  async function refreshCartCount() {
    const cart = await cartRequest('cart.js');
    updateCartCount(cart);
    return cart;
  }

  function announceCartError(message) {
    const status = document.querySelector('[data-cart-status]');
    if (status) status.textContent = message;
  }

  function confirmAdd(origin, cart) {
    updateCartCount(cart);
    document.dispatchEvent(new CustomEvent('madbxnny:cart-added', {
      detail: { origin }
    }));
  }

  // Add to cart from product card buttons
  document.addEventListener('click', (e) => {
    const addBtn = e.target.closest('[data-add-product]');
    if (addBtn) {
      e.preventDefault();
      e.stopPropagation();
      const variantId = addBtn.dataset.addProduct;
      if (!variantId) return;
      addBtn.disabled = true;
      const originalText = addBtn.textContent;
      queueCartRequest(async () => {
        await cartRequest('cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
        });
        return refreshCartCount();
      })
        .then(cart => {
          addBtn.textContent = 'Added to bag ✓';
          confirmAdd(addBtn, cart);
          setTimeout(() => {
            addBtn.textContent = originalText;
            addBtn.disabled = false;
          }, 1200);
        })
        .catch(error => {
          addBtn.textContent = 'Try again';
          announceCartError(error.message);
          setTimeout(() => {
            addBtn.textContent = originalText;
            addBtn.disabled = false;
          }, 1200);
        });
    }
  });

  // ============================================
  // PRODUCT FORM — variant picker, gallery, AJAX add
  // ============================================
  const productForm = document.querySelector('[data-product-form], #AddToCartForm');
  if (productForm) {
    const productData = JSON.parse(document.querySelector('[data-product-json]')?.textContent || 'null');
    const variantInput = productForm.querySelector('[name="id"]');
    const priceEl = document.querySelector('[data-product-price]');
    const comparePriceEl = document.querySelector('[data-product-compare-price]');
    const submitBtn = productForm.querySelector('[data-add-to-cart], #AddToCartButton');
    const submitBtnText = submitBtn?.querySelector('[data-add-to-cart-text]') || submitBtn;

    function getSelectedOptions() {
      const opts = [];
      productForm.querySelectorAll('.variant-picker').forEach(picker => {
        const active = picker.querySelector('.variant-picker__option.is-active');
        if (active) opts.push(active.dataset.value);
      });
      return opts;
    }

    function findVariant(opts) {
      if (!productData) return null;
      return productData.variants.find(v => {
        return v.options.every((o, i) => o === opts[i]);
      });
    }

    function updateVariant() {
      const opts = getSelectedOptions();
      const variant = findVariant(opts);
      if (!variant) {
        if (submitBtnText) submitBtnText.textContent = 'Unavailable';
        if (submitBtn) submitBtn.disabled = true;
        return;
      }
      if (variantInput) variantInput.value = variant.id;
      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      if (comparePriceEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          comparePriceEl.textContent = formatMoney(variant.compare_at_price);
          comparePriceEl.style.display = '';
        } else {
          comparePriceEl.style.display = 'none';
        }
      }
      if (submitBtn && submitBtnText) {
        if (variant.available) {
          submitBtn.disabled = false;
          submitBtnText.textContent = 'Add to bag';
        } else {
          submitBtn.disabled = true;
          submitBtnText.textContent = 'Sold out';
        }
      }
      // update URL
      if (history.replaceState) {
        const url = new URL(window.location);
        url.searchParams.set('variant', variant.id);
        history.replaceState({}, '', url);
      }
      // swap featured image if variant has one
      if (variant.featured_image && variant.featured_image.src) {
        const mainImg = document.querySelector('[data-product-main-image]');
        if (mainImg) mainImg.src = variant.featured_image.src;
      }
    }

    productForm.querySelectorAll('.variant-picker__option').forEach(opt => {
      opt.addEventListener('click', () => {
        const picker = opt.closest('.variant-picker');
        picker.querySelectorAll('.variant-picker__option').forEach(o => o.classList.remove('is-active'));
        opt.classList.add('is-active');
        updateVariant();
      });
    });

    // Quantity buttons
    const qInput = productForm.querySelector('.quantity__input');
    productForm.querySelectorAll('[data-quantity-change]').forEach(btn => {
      btn.addEventListener('click', () => {
        if (!qInput) return;
        const delta = parseInt(btn.dataset.quantityChange, 10);
        const current = parseInt(qInput.value, 10) || 1;
        qInput.value = Math.max(1, current + delta);
      });
    });

    // Product gallery thumbs
    document.querySelectorAll('[data-product-thumb]').forEach(thumb => {
      thumb.addEventListener('click', () => {
        const src = thumb.dataset.productThumb;
        const mainImg = document.querySelector('[data-product-main-image]');
        if (mainImg && src) mainImg.src = src;
        document.querySelectorAll('[data-product-thumb]').forEach(t => t.classList.remove('is-active'));
        thumb.classList.add('is-active');
      });
    });

    // Submit via AJAX
    productForm.addEventListener('submit', (e) => {
      e.preventDefault();
      if (submitBtn) submitBtn.disabled = true;
      const formData = new FormData(productForm);
      queueCartRequest(async () => {
        await cartRequest('cart/add.js', { method: 'POST', body: formData });
        return refreshCartCount();
      })
        .then(cart => {
          if (submitBtnText) submitBtnText.textContent = 'Added ✦';
          confirmAdd(submitBtn || productForm, cart);
          setTimeout(() => {
            window.location.href = window.MADBXNNY_ROUTES?.cart || cartUrl('cart');
          }, 850);
        })
        .catch(error => {
          if (submitBtnText) submitBtnText.textContent = error.message;
          announceCartError(error.message);
          if (submitBtn) submitBtn.disabled = false;
        });
    });
  }

  // ============================================
  // CART PAGE — update quantity / remove
  // ============================================
  let cartPageBusy = false;

  function changeCartLine(control, quantity, removing) {
    const row = control.closest('[data-cart-key]');
    const key = row?.dataset.cartKey;
    if (!key || cartPageBusy) return;
    cartPageBusy = true;
    row.classList.add('is-updating');
    const form = row.closest('form');
    form?.querySelectorAll('[data-cart-remove], [data-cart-quantity-change], [data-cart-quantity]').forEach(el => {
      el.disabled = true;
    });
    queueCartRequest(() => cartRequest('cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity })
    }))
      .then(cart => {
        updateCartCount(cart);
        row.classList.add(removing ? 'is-removing' : 'is-updated');
        setTimeout(() => window.location.reload(), removing ? 240 : 120);
      })
      .catch(error => {
        cartPageBusy = false;
        row.classList.remove('is-updating');
        form?.querySelectorAll('[data-cart-remove], [data-cart-quantity-change], [data-cart-quantity]').forEach(el => {
          el.disabled = false;
        });
        const input = row.querySelector('[data-cart-quantity]');
        if (input) input.value = input.defaultValue;
        announceCartError(error.message);
      });
  }

  document.addEventListener('click', (e) => {
    const removeBtn = e.target.closest('[data-cart-remove]');
    if (removeBtn) {
      e.preventDefault();
      changeCartLine(removeBtn, 0, true);
      return;
    }
    const quantityBtn = e.target.closest('[data-cart-quantity-change]');
    if (quantityBtn) {
      e.preventDefault();
      const input = quantityBtn.closest('.quantity')?.querySelector('[data-cart-quantity]');
      if (!input) return;
      const next = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(quantityBtn.dataset.cartQuantityChange, 10));
      input.value = next;
      changeCartLine(quantityBtn, next, false);
    }
  });

  document.addEventListener('change', e => {
    const input = e.target.closest('[data-cart-quantity]');
    if (!input) return;
    const quantity = parseInt(input.value, 10);
    if (!Number.isInteger(quantity) || quantity < 1) {
      input.value = input.defaultValue;
      return;
    }
    if (quantity !== parseInt(input.defaultValue, 10)) changeCartLine(input, quantity, false);
  });

  // Initial cart count refresh
  queueCartRequest(() => refreshCartCount()).catch(() => {});

  // ============================================
  // NEWSLETTER (Shopify customer form)
  // The success state is shown by Shopify via form posted state;
  // we just handle the inline visual transition for the simple form.
  // ============================================
  document.querySelectorAll('[data-newsletter-form]').forEach(form => {
    form.addEventListener('submit', () => {
      // visual feedback before Shopify processes redirect
      setTimeout(() => {
        const input = form.querySelector('input[type="email"]');
        if (input) input.placeholder = "you're in. ✦";
      }, 100);
    });
  });

  // ============================================
  // PREDICTIVE SEARCH (simple submit only — Shopify handles results)
  // ============================================
  const searchForm = document.querySelector('[data-search-form]');
  if (searchForm) {
    const input = searchForm.querySelector('input[name="q"]');
    if (input) input.focus();
  }

})();
